import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { flexbox, typography, color, space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Card from 'theme/card';
import Button from 'theme/buttons/btn';
import EmailConfirmedIcon from 'theme/icons/email-confirmed';
import translations from 'translations';

const Wrapper = styled.div`
  ${flexbox}
  ${space}

  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  min-height: 100%;

  & > div > .row-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  & > div > .row-2 > div {
    display: flex;
    flex-direction: row;
  }

  & > div > .row-2 > div > .col-2 {
    display: flex;
    flex-direction: column;
    max-width: 360px;
    justify-content: center;
    margin-left: ${themeGet('space.m')}px;
  }
`;

const Text = styled.p`
  ${typography}
  ${color}
  ${space}
`;

function EmailConfirmed({ onClose }) {
  const { languageCode } = useSelector((state) => state.config);

  return (
    <Wrapper>
      <Card width="100%" minWidth="240px" bg="white" borderColor="primary_100" py="l" px="s">
        <div className="row-2">
          <div>
            <EmailConfirmedIcon />

            <div className="col-2">
              <Text fontSize="h2" lineHeight="h2" fontWeight="bold" color="grey_600">
                {translations[languageCode]['Email confirmed']}
              </Text>

              <Text fontSize="h3" lineHeight="h3" fontWeight="medium" color="grey_400" mt="s">
                {translations[languageCode]['Your email is confirmed']}
              </Text>
            </div>
          </div>

          <Button
            onClick={onClose}
            style={{
              p: 2,
              mr: 'm',
            }}
            type="button"
            label={translations[languageCode].Close}
          />
        </div>
      </Card>
    </Wrapper>
  );
}

export default EmailConfirmed;
